import Letter from "./Letter";

function Guess(props) {
  let count = {};
  [...props.target].forEach((letter) => {
    if (count[letter]) {
      count[letter]++;
    } else {
      count[letter] = 1;
    }
  });

  [...props.word].forEach((letter, index) => {
    if (letter === props.target[index]) {
      count[letter]--;
    }
  });
  return (
    <div className="letter-row">
      {[...props.word].map((letter, index) => {
        let colour;
        if (letter === props.target[index]) {
          colour = "green";
        } else if (props.target.includes(letter) && count[letter] > 0) {
          colour = "yellow";
          count[letter]--;
        } else {
          colour = "grey";
        }
        return (<Letter key={index} letter={letter} colour={colour}/>);
      })}
    </div>
  );
}

export default Guess;